<script>
	const _ = require('underscore');
	const page = require('page');

	const model = require('model/model');
	const utilities = require('utilities');
	const getWordCount = utilities.getWordCount;

	const assignmentService = require('services/assignmentService');
	const classBOKUtilities = require('utilities/classBOKUtilities');
	const getClassBok = classBOKUtilities.get;
	const addToClassBoK = classBOKUtilities.create;
	const removeFromClassBoK = classBOKUtilities.remove;

	const alertUtilities = require('utilities/alertUtilities');
	const success = alertUtilities.success;

	const { fireEvent, events } = require('utilities/analyticsUtilities');
	const CBOK_POST_STUDENT_ENTRY = events.CBOK_POST_STUDENT_ENTRY;
	const CBOK_REMOVE_STUDENT_ENTRY = events.CBOK_REMOVE_STUDENT_ENTRY;

	const { assetUrl } = require('utilities/urlUtilities');
	const pubsub = require('events/pubsub');

	module.exports = {
		components: {
			'book-of-knowledge-assignment': require('components/book-of-knowledge-assignment.vue').default,
			'book-of-knowledge-entry': require('components/book-of-knowledge-entry.vue').default,
			'article-image': require('components/article-image.vue').default,
			'bbok-badge-icon': require('components/svg/bbok-badge-icon.vue').default,
			'bok-bookmark-icon': require('components/svg/bok-bookmark-icon.vue').default,
			'apple-icon': require('components/svg/apple-icon.vue').default,
			'lightning-icon': require('components/svg/lightning-icon.vue').default,
			'bok-note': require('components/bok-note.vue').default,
			'tab-container': require('components/tab-container.vue').default
		},
		props: ['article', 'orderedStudents', 'assignmentDeadline', 'routeContext', 'assignmentId', 'assessment'],
		modelData: ['bokResultsByStudent', 'student', 'classBok'],
		data() {
			return {
				counts: {},
				articlesRead: 0,
				wordsWritten: 0,
				wordsRead: 0,
				totalWords: 0,
				cbokActionInProgress: null,
				studentCbokLoading: false
			};
		},

		mounted() {
			let bokResultsByStudent = this.bokResultsByStudent;
			if (!bokResultsByStudent) {
				model.set('bokResultsByStudent', this.article.articleList[0].uuid);
			}
			this.getCbok();
		},
		computed: {
			pastDue() {
				let deadline = this.assignmentDeadline ? this.assignmentDeadline * 1000 : 0;
				let now = Date.now();

				return deadline < now;
			},
			includesSupplemental() {
				let article = this.article;
				let assessment = this.assessment;
				return article.supplemental_texts && (assessment.options.challenge || assessment.options.support);
			},
			includesDecodables() {
				return this.assessment.options.decodables && this.article.dteGroups;
			},
			articleList() {
				let article = this.article;
				let assessment = this.assessment;
				let includesSupplemental = this.includesSupplemental;
				let list = [];
				if (article) {
					list = article.articleList;
				}
				if (includesSupplemental) {
					let supplemental = [];

					for (let supplementalType in article.supplemental_texts) {
						if (assessment.options[supplementalType]) {
							for (let supplementalId in article.supplemental_texts[supplementalType]) {
								let a = article.supplemental_texts[supplementalType][supplementalId];
								supplemental.push(
									_.assign({}, a, {
										[supplementalType]: true
									})
								);
							}
						}
					}
					list = list.concat(supplemental);
				}

				if (this.includesDecodables) {
					const assignedDecodables = new Set(assessment.options.decodables);
					for (const dteGroup of article.dteGroups) {
						if (assignedDecodables.has(dteGroup.id)) {
							list = [...list, ...Object.values(dteGroup.articles)];
						}
					}
				}

				return list;
			},
			selectedStudent() {
				let selected = null;
				let student = this.student;
				let orderedStudents = this.orderedStudents;

				if (orderedStudents && orderedStudents.length) {
					orderedStudents.every(s => {
						if (s.uid === student) {
							selected = s;
							return false;
						}
						return true;
					});
				}
				return selected;
			},
			cbokBySuid() {
				let classBok = this.classBok;
				let assignmentId = this.assignmentId;
				let bySuid = {};

				if (classBok && classBok[assignmentId]) {
					let cbok = classBok[assignmentId];
					let cbokContent = cbok.content;
					if (cbokContent && cbokContent.length) {
						cbokContent.reduce((acc, entry) => {
							if (entry.suid) {
								if (acc[entry.suid]) {
									acc[entry.suid][entry.cpid] = entry;
								} else {
									acc[entry.suid] = {
										[entry.cpid]: entry
									};
								}
							}
							return acc;
						}, bySuid);
					}
				}
				return bySuid;
			},
			workspacesByArticle() {
				let orderedStudents = this.orderedStudents;
				let studentNames = utilities.unambiguousStudentLabels(orderedStudents);
				let pastDue = this.pastDue;
				let pid = this.bokResultsByStudent;
				let article = this.article;
				let cbokBySuid = this.cbokBySuid;
				let counts = {};
				let workspaceMap = {};

				if (orderedStudents && article) {
					article.articleList.forEach(a => {
						counts[a.uuid] = 0;
						workspaceMap[a.uuid] = [];
					});

					if (article.supplemental_texts) {
						for (let supplementalType in article.supplemental_texts) {
							for (let supplementalId in article.supplemental_texts[supplementalType]) {
								let a = article.supplemental_texts[supplementalType][supplementalId];
								counts[a.uuid] = 0;
								workspaceMap[a.uuid] = [];
							}
						}
					}

					if (article.dteGroups) {
						for (const dteGroup of article.dteGroups) {
							for (const decodableId in dteGroup.articles) {
								counts[decodableId] = 0;
								workspaceMap[decodableId] = [];
							}
						}
					}

					orderedStudents.forEach(student => {
						let suid = student.uid;
						for (var key in student.aad) {
							let ws = student.aad[key];
							if (typeof ws.b !== 'undefined' || ws.s === 's') {
								let cbokEntry = cbokBySuid && cbokBySuid[suid] && cbokBySuid[suid][pid];
								workspaceMap[key].push(
									_.assign({}, ws, {
										pid,
										pastDue,
										name: studentNames[suid],
										uid: suid,
										suid,
										id: cbokEntry ? cbokEntry.id : suid + pid,
										inCbok: !!cbokEntry
									})
								);
								counts[key]++;
							}
						}
					});
				}

				this.counts = counts;
				return workspaceMap;
			},
			currentClassAssignment() {
				let article = this.article;
				let pid = this.bokResultsByStudent;
				let workspacesByArticle = this.workspacesByArticle;
				let includesSupplemental = this.includesSupplemental;

				let pmd = null;
				let workspaces = null;
				let current = null;

				if (workspacesByArticle && pid && workspacesByArticle[pid]) {
					workspaces = workspacesByArticle[pid];
				}

				if (article && article.articles && article.articles[pid]) {
					current = article.articles[pid];
				} else if (includesSupplemental) {
					for (let supplementalType in article.supplemental_texts) {
						if (article.supplemental_texts[supplementalType][pid]) {
							current = article.supplemental_texts[supplementalType][pid];
						}
					}
				}
				if (current) {
					pmd = _.assign(
						{},
						{
							title: current.title,
							img: current.img
						}
					);
				}

				return _.assign(
					{},
					{
						pmd,
						workspaces,
						assigned: true
					}
				);
			},
			currentStudentAssignment() {
				let pastDue = this.pastDue;
				let article = this.article;
				let selectedStudent = this.selectedStudent;
				let cbokBySuid = this.cbokBySuid;
				let articleList = this.articleList;
				let pmd = article;
				let workspaces = null;

				let articlesRead = 0;
				let wordsWritten = 0;
				let wordsRead = 0;
				let totalWords = 0;

				if (selectedStudent && selectedStudent.aad) {
					let suid = selectedStudent.uid;
					workspaces = articleList.reduce((acc, a) => {
						let ws = selectedStudent.aad[a.uuid];
						let pid = a.uuid;
						totalWords += a.wordCount;
						if (ws && (typeof ws.b !== 'undefined' || ws.s === 's')) {
							let cbokEntry = cbokBySuid && cbokBySuid[suid] && cbokBySuid[suid][pid];
							articlesRead += 1;
							wordsRead += a.wordCount;

							if (ws.b && ws.b.length) {
								wordsWritten += getWordCount(ws.b);
							}
							if (ws.brev && ws.brev.length) {
								wordsWritten += getWordCount(ws.brev);
							}

							acc.push(
								_.assign({}, ws, {
									pid,
									pastDue,
									id: cbokEntry ? cbokEntry.id : suid + pid,
									inCbok: !!cbokEntry,
									suid
								})
							);
						}
						return acc;
					}, []);

					workspaces.sort((a, b) => b.tf - a.tf);
				}

				this.articlesRead = articlesRead;
				this.wordsWritten = wordsWritten;
				this.wordsRead = wordsRead;
				this.totalWords = totalWords;

				return _.assign(
					{},
					{
						pmd,
						workspaces,
						assigned: true
					}
				);
			},
			currentAssignment() {
				let selectedStudent = this.selectedStudent;
				let currentStudentAssignment = this.currentStudentAssignment;
				let currentClassAssignment = this.currentClassAssignment;

				return selectedStudent ? currentStudentAssignment : currentClassAssignment;
			},
			loaderImageSrc() {
				return assetUrl('/assets/dist/images/loader.gif');
			}
		},
		methods: {
			onStudentClick(uid) {
				model.set('student', uid);
			},
			goToBigBok() {
				let routeContext = this.routeContext;
				let student = this.student;
				let classCode = routeContext.params.classCode;
				let aid = routeContext.params.assignmentId;

				model.set('studentProgressHash', {
					resultsTab: 'classresults',
					student: student,
					assessmentTab: 'bookofknowledge',
					url: '/assignment/' + classCode + '/' + aid + '/assessmentarticle'
				});

				page('/assignments');
				model.set({
					assignmentTab: 'progress',
					studentProgressTab: 'articleADay',
					classCode: routeContext.params.classCode,
					studentId: this.student,
					isp: 'bbok-progress'
				});
			},
			getCbok() {
				this.studentCbokLoading = true;
				getClassBok(this.assignmentId).finally(() => (this.studentCbokLoading = false));
			},
			addToCbok(entry) {
				let routeContext = this.routeContext;
				let aid = this.assignmentId;
				let cc = routeContext.params.classCode;
				let uid = entry.suid;
				let a = entry.pid;
				let suids = [uid];

				this.cbokActionInProgress = entry.id;

				fireEvent(CBOK_POST_STUDENT_ENTRY, {
					cc,
					aid,
					suids,
					pid: a
				});
				addToClassBoK(aid, cc, suids, a, entry)
					.then(() => {
						success('Entry added to the Class Book of Knowledge');
					})
					.finally(() => {
						this.cbokActionInProgress = null;
					});
			},
			removeFromCbok(entry) {
				let routeContext = this.routeContext;
				let id = entry.id;
				let aid = this.assignmentId;
				let cc = routeContext.params.classCode;
				let uid = entry.suid;
				let a = entry.pid;

				this.cbokActionInProgress = entry.id;

				fireEvent(CBOK_REMOVE_STUDENT_ENTRY, {
					cc,
					aid,
					pid: a,
					suids: [uid]
				});

				removeFromClassBoK(id, aid, a, cc, uid)
					.then(() => {
						success('Entry removed from the Class Book of Knowledge');
					})
					.finally(() => {
						this.cbokActionInProgress = null;
					});
			},
			setTeacherNote(workspace, value) {
				assignmentService
					.setBoKNote({
						uid: workspace.suid,
						a: workspace.pid,
						aid: this.assignmentId,
						tn: value
					})
					.then(() => {
						pubsub.publish('assessment-needs-reload');
					});
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';
	@import 'config/variables';

	.bok-student-results {
		.article-selector {
			h2 {
				margin-bottom: 0;
			}

			.bok-article-nav {
				white-space: normal;

				.tab-list {
					display: flex;
					flex-wrap: wrap;
				}

				.bok-article-nav-item {
					display: flex;
					align-items: center;
					font-weight: 500;
					border-radius: 4px;
					margin: 0 0.5rem 0.5rem 0;
					padding: 0.5rem 1rem;
					background-color: $c-blue-lighter;
					border: none;
					width: 15rem;
					text-align: left;

					.meta-container {
						flex: 1;

						.nav-title {
							color: $c-slate-dark;
						}

						.nav-entries {
							font-size: 0.75rem;
						}
					}

					.article-image {
						margin-right: 1rem;

						.article-featured-image-container {
							height: 3rem;
							width: 3rem;
						}
					}

					svg {
						min-width: 20px;
					}

					&.active,
					&:hover {
						.nav-title,
						.nav-entries {
							color: $c-blue;
						}
						.lightning-icon {
							stroke: $c-blue;
						}
						.apple-icon {
							stroke: $c-blue;
						}
					}
				}
			}
		}

		.result-header {
			margin: 0.5rem 0 1rem 0;

			.bbok-link {
				display: block;
				margin-top: 0.5rem;
				font-weight: 500;

				.bbok-badge-icon {
					margin-right: 1rem;
					display: block;
				}
			}

			.bok-stats {
				display: block;
				margin-top: 1rem;
			}
		}
	}

	@media only screen and (min-width: $bp-width-med) {
		.bok-student-results {
			.result-header {
				display: flex;
				flex-wrap: wrap;
				align-items: center;

				.bbok-link {
					flex: 1;

					.bbok-badge-icon {
						display: inline-block;
					}
				}

				.bok-stats {
					flex: 1;
				}
			}
		}
	}
</style>
<template>
	<div class="bok-student-results wrapper">
		<div
			v-if="!selectedStudent"
			class="article-selector">
			<h2>Articles</h2>
			<tab-container
				class="bok-article-nav"
				model-key="bokResultsByStudent">
				<button
					v-for="subArticle in articleList"
					v-if="!subArticle.decodableTeacherEdition"
					class="bok-article-nav-item"
					:key="subArticle.uuid"
					:data-tab="subArticle.uuid">
					<article-image
						:image-url="subArticle.img"
						:alt-text="subArticle.imgAlt"></article-image>
					<div class="meta-container">
						<div class="nav-title">{{ subArticle.title }}</div>
						<div class="nav-entries">{{ counts[subArticle.uuid] }} entr{{ counts[subArticle.uuid] === 1 ? 'y' : 'ies' }}</div>
					</div>
					<lightning-icon v-if="subArticle.challenge"></lightning-icon>
					<apple-icon v-if="subArticle.support"></apple-icon>
				</button>
			</tab-container>
		</div>
		<div
			v-if="selectedStudent"
			class="result-header">
			<a
				class="bbok-link"
				@click="goToBigBok">
				<bbok-badge-icon></bbok-badge-icon>
				View {{ selectedStudent.firstName }}'s Big Book of Knowledge
			</a>
			<div class="bok-stats">
				<div>
					<div class="bok-stat">{{ articlesRead }} of {{ articleList.length }}</div>
					<div class="bok-stat-subtitle text-muted font-small">Articles read</div>
				</div>
				<div>
					<div class="bok-stat">{{ wordsRead | commaGrouping }} of {{ totalWords | commaGrouping }}</div>
					<div class="bok-stat-subtitle text-muted font-small">Words read</div>
				</div>
				<div>
					<div class="bok-stat">{{ wordsWritten | commaGrouping }}</div>
					<div class="bok-stat-subtitle text-muted font-small">Words written</div>
				</div>
			</div>
		</div>
		<book-of-knowledge-assignment
			v-if="currentAssignment"
			:assignment="currentAssignment"
			ref="bokResultsByStudentPanel"
			:data-panel="bokResultsByStudent">
			<div
				v-if="currentAssignment.workspaces"
				slot="entry-container"
				class="card-container">
				<book-of-knowledge-entry
					v-for="workspace in currentAssignment.workspaces"
					:key="workspace.id"
					:entry="workspace"
					:article="currentAssignment.pmd.allArticles && currentAssignment.pmd.allArticles[workspace.pid]"
					:assigned="assessment && assessment.options.bok"
					:student="selectedStudent ? { name: selectedStudent.firstName } : null"
					:on-student-click="onStudentClick">
					<div slot="actions">
						<template v-if="!studentCbokLoading">
							<span
								class="add-to-cbok"
								:class="{
									'in-cbok': workspace.inCbok
								}">
								<img
									v-if="cbokActionInProgress === workspace.id"
									:src="loaderImageSrc"
									class="loading-indicator"
									role="status"
									alt="Loading" />
								<bok-bookmark-icon
									v-if="workspace.s === 's' && !workspace.inCbok && cbokActionInProgress !== workspace.id"
									@click.native="addToCbok(workspace)">
								</bok-bookmark-icon>
								<bok-bookmark-icon
									v-if="workspace.s === 's' && workspace.inCbok && cbokActionInProgress !== workspace.id"
									@click.native="removeFromCbok(workspace)">
								</bok-bookmark-icon>
							</span>
							<bok-note
								editable
								@change-note="value => setTeacherNote(workspace, value)"
								:student-name="selectedStudent ? selectedStudent.firstName : workspace.name"
								:value="workspace.teacherNote"></bok-note>
						</template>
					</div>
				</book-of-knowledge-entry>
			</div>
		</book-of-knowledge-assignment>
	</div>
</template>
